define(function (require) {
    var $ = require("jquery");
    var pageFavoriteRegistry = window.pageFavoriteRegistry || { clientIds: {} };
    var dataLayer = window.dataLayer || [];

    $(document).ready(function () {
        var $filterFavorites = $("#filterFavorites");
        var $favoriteCards = $(".favorites-listing .favorite");

        $filterFavorites.on("changed.bs.select", function (e, clickedIndex, newValue, oldValue) {
            var selectedValue = $(this).val() || "all";

            $favoriteCards.each(function () {
                var $card = $(this);
                if (selectedValue === "" || selectedValue === "all") {
                    $card.show();
                } else {
                    if ($card.hasClass(selectedValue)) {
                        $card.show();
                    } else {
                        $card.hide();
                    }
                }
            });
        });

        var $favoriteListLink = $(".favorite-list-link");

        $favoriteListLink.on("click", function () {
            var $link = $(this);
            var favoriteType = $link.data("favoritetype") || "Web Page";
            var favoriteTitle = $link.text();

            dataLayer.push({
                event: "interactFavorite",
                favoriteType: favoriteType,
                favoriteTitle: favoriteTitle
            });
        });

        var $favoriteButton = $("button.favorite-page,button.favorite-list-item");
        $favoriteButton.on("click", function () {
            var $button = $(this);

            var clientId = $button.data("favoriteclientid") || "";
            var favoriteData = pageFavoriteRegistry.clientIds[clientId] || {
                itemId: "",
                favoriteTypeId: "",
                itemTypeData: {}
            };

            var apiData = "itemId=" + encodeURIComponent(favoriteData.itemId) + "&favoriteTypeId=" + encodeURIComponent(favoriteData.favoriteTypeId) + "&itemTypeData=" + encodeURIComponent(JSON.stringify(favoriteData.itemTypeData));

            if ($button.is('[aria-pressed*="true"]')) {
                removeFavorite($button, apiData, pageFavoriteRegistry.favoriteButtonValue || "Favorite", pageFavoriteRegistry.favoriteLabelValue);
            } else if ($button.is('[aria-pressed*="false"]')) {
                addFavorite($button, apiData, pageFavoriteRegistry.unfavoriteButtonValue || "Un-Favorite", pageFavoriteRegistry.unfavoriteLabelValue);
            }
        });

        if ($favoriteButton.is('[aria-pressed*="true"]')) {
            $favoriteButton.attr("aria-label", pageFavoriteRegistry.favoriteLabelValue);
        } else if ($favoriteButton.is('[aria-pressed*="false"]')) {
            $favoriteButton.attr("aria-label", pageFavoriteRegistry.unfavoriteLabelValue);
        }

        $favoriteButton.css("visibility", "visible");
    });

    function addFavorite(button, apiData, buttonValue, buttonLabel) {
        $.getJSON("/api/Favorites/Add?" + apiData).done(function (data) {
            if (data && data.CurrentPageIsFavorited && data.CurrentPageIsFavorited === "true") {
                button.attr("aria-pressed", "true");
                button.find(".link-text").text(buttonValue);

                // we don't need this to favorite a page as the css already shows the heart
                // button.html('<span class="fa fa-heart"></span><span class="link-text">Un-Favorite</span></button>');

                var favoriteType = data.FavoriteTypeName || "Web Page";
                var favoriteTitle = data.ItemTitle || window.document.title;
                dataLayer.push({
                    event: "markedFavorite",
                    favoriteType: favoriteType,
                    favoriteTitle: favoriteTitle
                });
            }
        });
    }

    function removeFavorite(button, apiData, buttonValue, buttonLabel) {
        $.getJSON("/api/Favorites/Remove?" + apiData).done(function (data) {
            if (data && data.CurrentPageIsFavorited && data.CurrentPageIsFavorited === "false") {
                button.attr("aria-pressed", "false");
                button.find(".link-text").text(buttonValue);

                // we don't need this to favorite a page as the css already shows the heart
                // button.html('<span class="fa fa-heart"></span><span class="link-text">Favorite</span></button>');

                var favoriteType = data.FavoriteTypeName || "Web Page";
                var favoriteTitle = data.ItemTitle || window.document.title;
                dataLayer.push({
                    event: "markedUnfavorite",
                    favoriteType: favoriteType,
                    favoriteTitle: favoriteTitle
                });
            }
        });
    }
});
